{
  "tabs": {
    "chat": "Mkparịta ụka",
    "reminders": "Cheta",
    "calendar": "Kalenda",
    "settings": "Ntọala"
  },
  "common": {
    "cancel": "Kwụsị",
    "save": "Chekwaa",
    "confirm": "Kwenye",
    "delete": "Hichapụ",
    "back": "Laghachi",
    "close": "Mechie",
    "edit": "Dezie",
    "search": "Chọọ",
    "all": "Nke niile",
    "loading": "Na-ebudata...",
    "error": "Ihe mechara mee",
    "notFound": "Ahụghị ya",
    "tryAgain": "Biko nwalee ọzọ",
    "retry": "Nwale ọzọ",
    "undo": "Weghachite",
    "pullToRefresh": "Dọta iji melite",
    "justNow": "nkeji ole na ole gara aga"
  },
  "auth": {
    "welcome": "Nnọọ na FishMemory",
    "tagline": "Onye enyemaka ncheta WhatsApp gị, ugbu a n’akpa gị.",
    "subtitle": "Onye enyemaka ncheta WhatsApp gị, ugbu a n’akpa gị.",
    "phoneLabel": "Nọmba WhatsApp gị",
    "phoneHint": "Anyị ga-eziga koodu nkwenye site na WhatsApp",
    "invalidPhone": "Biko tinye nọmba ekwentị ziri ezi",
    "continue": "Gaa n’ihu",
    "enterPhone": "Tinye nọmba WhatsApp gị",
    "phonePlaceholder": "Nọmba ekwentị",
    "sendCode": "Zipu Koodu",
    "verifyTitle": "Nyochaa nọmba gị",
    "otpSentTo": "E zigara koodu 6-nọmba na {{phone}} site na WhatsApp",
    "enterFullCode": "Biko tinye nọmba 6 niile",
    "invalidOtp": "Koodu ezighi ezi. Biko nwalee ọzọ.",
    "otpFailed": "Ezighi ezi izipu koodu. Nwale ọzọ.",
    "otpResent": "Koodu ezitere ọzọ",
    "resendIn": "Zipu ọzọ na {{seconds}}s",
    "resendCode": "Zipu koodu ọzọ",
    "enterOtp": "Tinye koodu ezitere gị na WhatsApp",
    "verify": "Nyochaa",
    "resend": "Zipu koodu ọzọ",
    "wrongNumber": "Nọmba ezighi ezi?",
    "backToPhone": "Laghachi na ekwentị",
    "editPhone": "Dezie nọmba ekwentị",
    "error": "Njehie",
    "setupTitle": "Ka anyị hazie ya",
    "setupSubtitle": "Ị nwere ike ịgbanwe nke a mgbe e mesịrị na Ntọala",
    "namePlaceholder": "Aha gị",
    "letsGo": "Mechaa ntọala",
    "skipForNow": "Gafe ugbu a"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tinye ozi...",
    "inputPlaceholder": "Tinye ozi...",
    "typing": "FishMemory na-ede...",
    "online": "N'ịntanetị",
    "connecting": "Na-ejikọ...",
    "reconnecting": "Na-ejikọgharịa...",
    "offline": "Na-enweghị njikọ",
    "empty": "Malite mkparịta ụka",
    "emptyHint": "Mepụta ncheta, lelee oge gị, ma ọ bụ jụọ enyemaka.",
    "emptyAction": "Zipu ncheta atụ",
    "actions": "Omume mkparịta ụka",
    "keep": "Chekwaa ozi",
    "clearTitle": "Hichapụ mkparịta ụka",
    "clearConfirm": "Hichapụ ozi niile na ngwaọrụ a? A pụghị iweghachi ya.",
    "clear": "Hichapụ mkparịta ụka",
    "optionSelected": "Họrọ: {{label}}",
    "sendingSelection": "Na-eziga...",
    "connectionLost": "Na-ejikọgharịa..."
  },
  "reminders": {
    "title": "Ncheta m",
    "active": "Na-arụ ọrụ",
    "today": "Taa",
    "thisWeek": "Izu a",
    "history": "Akụkọ ihe mere eme",
    "items": "ihe",
    "emptyTitle": "Enweghị ncheta",
    "emptySubtitle": "Mepụta otu site na mkparịta ụka, ọ ga-apụta ebe a.",
    "emptyAction": "Mepee mkparịta ụka",
    "filterActive": "Na-arụ ọrụ",
    "filterToday": "Taa",
    "filterWeek": "Izu a",
    "filterHistory": "Akụkọ ihe mere eme",
    "emptyState": "Enweghị ncheta. Malite mkparịta ụka!",
    "swipeDone": "Mechara",
    "swipeSnooze": "Kwụsịtụ",
    "swipeDelete": "Hichapụ",
    "search": "Chọọ ncheta...",
    "upcoming": "Na-abịa",
    "completed": "Mechara",
    "overdue": "Gafere oge",
    "tomorrow": "Echi",
    "synced": "Kwado {{value}}",
    "swipeHint": "Dọta ncheta maka omume ndị ọzọ",
    "noResults": "Enweghị ncheta dabara na ọchụchọ gị",
    "noResultsHint": "Nwale okwu ọzọ ma ọ bụ hichapụ ọchụchọ",
    "deleteAllFailed": "E meghị hichapụ ncheta niile"
  },
  "calendar": {
    "title": "Kalenda",
    "today": "Taa",
    "tomorrow": "Echi",
    "completed": "mechara",
    "noEvents": "Enweghị ihe omume",
    "noEventsSubtitle": "Họrọ ụbọchị iji hụ ncheta na ihe omume kalenda.",
    "googleEvent": "Kalenda Google",
    "legendActive": "Na-arụ ọrụ",
    "legendRecurring": "Na-emeghachi",
    "legendDone": "Mechara",
    "legendGoogle": "Google",
    "previousMonth": "Ọnwa gara aga",
    "nextMonth": "Ọnwa ọzọ",
    "previousYear": "Afọ gara aga",
    "nextYear": "Afọ ọzọ",
    "goToToday": "Gaa taa",
    "all": "Nke niile",
    "active": "Na-arụ ọrụ",
    "done": "Mechara",
    "paused": "Kwụsịrị"
  },
  "settings": {
    "title": "Ntọala",
    "profile": "Profaili",
    "name": "Aha ngosi",
    "enterName": "Tinye aha gị",
    "language": "Asụsụ",
    "uiLanguage": "Asụsụ ngwa",
    "uiLanguageHelp": "Na-agbanwe UI ngwa, akara kalenda, na ntụziaka nhazi na ngwaọrụ a naanị.",
    "serverLanguage": "Asụsụ mkparịta ụka",
    "serverLanguageHelp": "Na-agbanwe asụsụ nke nzaghachi sava na ozi ncheta maka akaụntụ gị.",
    "timezone": "Oge mpaghara",
    "currentTimezone": "Oge mpaghara ugbu a",
    "timezoneHelp": "A na-egosi oge ncheta niile na oge mpaghara a.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Chekwaa oge mpaghara",
    "timezoneSaved": "Oge mpaghara emelitere",
    "detect": "Chọpụta",
    "detectFailed": "Enweghị ike ịchọpụta oge mpaghara",
    "autoDetect": "Chọpụta akpaka site na GPS",
    "notifications": "Nkwupụta",
    "notificationsHelp": "Ncheta na-esote na-achịkwa ịdọ aka ná ntị ugboro ugboro mgbe e zigara ncheta. Ikike nkwupụta na ngwaọrụ ka na-achịkwa na ntọala ekwentị gị.",
    "pushEnabled": "Nkwupụta Push",
    "autoDoneOnFire": "Akpaka gosipụta dị ka emechara mgbe e zigara",
    "autoDoneOnFireDesc": "Mgbe ọ kwụsịrị, ncheta na-anọgide na-arụ ọrụ ruo mgbe ị ga-egosi ha dị ka emechara.",
    "googleCalendar": "Kalenda Google",
    "google": "Kalenda Google",
    "googleConnected": "Ejikọrọ",
    "googleDisconnected": "Ejikọghị",
    "googleConnectedHelp": "Enwere ike ịkwado ncheta ọhụrụ na kalenda gị akpaka.",
    "googleDisconnectedHelp": "Jikọọ Kalenda Google iji mee ka ncheta na ihe omume kwekọọ.",
    "googleConnectFailed": "E meghị jikọọ Kalenda Google",
    "connected": "Ejikọrọ",
    "disconnected": "Ejikọghị",
    "connect": "Jikọọ",
    "disconnect": "Wepụ njikọ",
    "autoSync": "Kwado ncheta ọhụrụ akpaka",
    "autosync": "Kwado ncheta ọhụrụ akpaka",
    "subscription": "Ndebanye aha",
    "trialUsed": "Nnwale: {{used}}/{{total}} eji",
    "trialStatus": "Nnwale dị",
    "activeStatus": "Ndebanye aha dị",
    "expiredStatus": "Ndebanye aha agwụla",
    "unsubscribedStatus": "Enweghị ndebanye aha",
    "about": "Banyere",
    "version": "Ụdị",
    "logout": "Pụọ",
    "logoutTitle": "Pụọ",
    "logoutConfirm": "Ị nwere ike ịpụ n’ezie?",
    "noName": "Enweghị aha etinyere",
    "serverConnection": "Njikọ sava",
    "serverUrl": "URL sava",
    "serverEdit": "Dezie",
    "saveReconnect": "Chekwaa ma jikọọgharịa",
    "resetDefault": "Tọgharịa ndabara",
    "invalidServerUrlTitle": "URL sava ezighi ezi",
    "invalidServerUrlMessage": "Tinye URL sava http ma ọ bụ https ziri ezi, dịka https://example.com",
    "uiLanguageChangeFailed": "E meghị mgbanwe asụsụ ngwa. Biko nwalee ọzọ.",
    "serverLanguageChangeFailed": "E meghị mgbanwe asụsụ mkparịta ụka. Biko nwalee ọzọ.",
    "timezoneChangeFailed": "E meghị mgbanwe oge mpaghara. Biko nwalee ọzọ.",
    "autoSyncChangeFailed": "E meghị melite nkwado akpaka. Biko nwalee ọzọ.",
    "nameChangeFailed": "E meghị melite aha ngosi. Biko nwalee ọzọ.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Nkọwa ncheta",
    "editTime": "Dezie Oge",
    "rename": "Gbanwee aha",
    "snooze": "Kwụsịtụ",
    "snooze15": "Kwụsịtụ nkeji 15",
    "pause": "Kwụsị",
    "pauseReminder": "Kwụsị ncheta",
    "resume": "Gaa n’ihu",
    "resumeReminder": "Gaa n’ihu ncheta",
    "skip": "Gafe nke na-esote",
    "skipOccurrence": "Gafe oge a",
    "syncGoogle": "Kwado na Google",
    "delete": "Hichapụ",
    "deleteTitle": "Hichapụ Ncheta",
    "deleteConfirm": "A ga-ehichapụ ncheta a ruo mgbe ebighị ebi.",
    "deleteRecurringTitle": "Hichapụ Ncheta Na-emeghachi",
    "deleteRecurringMessage": "Ị chọrọ ịgafe oge a ma ọ bụ hichapụ usoro niile?",
    "deleteThisOccurrence": "Gafe oge a",
    "deleteEntireSeries": "Hichapụ usoro niile",
    "done": "Mechara",
    "markDone": "Gosi dị ka emechara",
    "undo": "Weghachite",
    "undoPrompt": "Chọrọ ka ọ bụrụ na-arụ ọrụ ọzọ? Weghachite ya ugbu a.",
    "recurring": "Na-emeghachi",
    "nextRun": "Oge na-esote",
    "oneTime": "Otu oge",
    "pending": "Na-echere",
    "sent": "Ezitere",
    "paused": "Kwụsịrị",
    "active": "Na-arụ ọrụ",
    "snoozed": "Kwụsịrịtụ",
    "localTime": "Egosi na oge mpaghara gị",
    "recurrence": "Mmeghachi",
    "created": "E kere",
    "tags": "Mkpado",
    "fireCount": "Ugboro e zigara",
    "actions": "Omume",
    "none": "Ọ dịghị",
    "snoozeFailed": "E meghị kwụsịtụ ncheta",
    "pauseFailed": "E meghị kwụsị ncheta",
    "resumeFailed": "E meghị gaa n’ihu ncheta",
    "skipFailed": "E meghị gafe ncheta",
    "doneFailed": "E meghị gosipụta dị ka emechara",
    "undoFailed": "E meghị weghachite ọnọdụ ncheta",
    "deleteFailed": "E meghị hichapụ ncheta",
    "rescheduleTitle": "Ị ga-emegharị oge?",
    "rescheduleMsg": "Ncheta a gafere oge. Ị chọrọ imegharị ya?",
    "reschedule15": "N'ime nkeji 15",
    "reschedule60": "N'ime otu elekere",
    "keepOverdue": "Jide ya dị ka o si dị"
  },
  "onboarding": {
    "slide1Title": "Nnọọ na FishMemory",
    "slide1Sub": "Onye enyemaka ncheta gị nkeonwe — nke WhatsApp na-arụ ọrụ na akpa gị.",
    "slide2Title": "Mkparịta ụka dị mfe",
    "slide2Sub": "Tinye ncheta dịka ị na-eche: \"Cheta m ka m kpọọ mama echi na elekere 3pm\" — anyị ga-eme ihe ndị ọzọ.",
    "slide3Title": "Echefula ihe ọ bụla",
    "slide3Sub": "Nweta ịdọ aka ná ntị n'oge, hazie na mkpado, ma nọgide na-elekọta ihe niile dị mkpa.",
    "getStarted": "Malite",
    "next": "Na-esote",
    "firstReminderTitle": "Mepụta ncheta mbụ gị!",
    "firstReminderHint": "Nwale itinye ihe dịka:",
    "firstReminderExample": "Cheta m ka m ṅụọ mmiri echi na elekere 9 AM",
    "gotIt": "Aghọtala!",
    "notifRationaleTitle": "Nọgide na oge",
    "notifRationaleBody": "FishMemory chọrọ ịdọ aka ná ntị iji cheta gị n'oge. Ị ga-enweta naanị ịdọ aka ná ntị maka ncheta ị kere.",
    "notifRationaleAllow": "Kwado Nkwupụta",
    "notifRationaleLater": "O nwere ike mechaa",
    "swipeHint": "Dọta aka nri maka omume ngwa ngwa →",
    "calendarDragHint": "Dọta iji gbatịa ↕"
  }
}
